import React, { useEffect, useState } from 'react';
import { db } from '../../services/firebase';
import { collection, getDocs, addDoc, Timestamp } from 'firebase/firestore';

const SECTION_MAP = [
  { header: 'Coffee', category: 'COFFEE' },
  { header: 'Milk Based', category: 'MILKBASED' },
  { header: 'Non Coffee', category: 'NON-COFFEE' },
  { header: 'Dessert', category: 'FOOD' },
  { header: 'Toasts & Sliders', category: 'TOASTS_SLIDERS' },
  { header: 'Bowls', category: 'BOWLS' },
  { header: 'Pastries', category: 'PASTRIES' },
];

const WaiterTab = () => {
  const [menuItems, setMenuItems] = useState([]);
  const [cart, setCart] = useState([]);
  const [tableNumber, setTableNumber] = useState('');
  const [orderNotes, setOrderNotes] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 700);
  // Pour Over Beans
  const [pourOverBeans, setPourOverBeans] = useState([]);
  // Modal state
  const [modal, setModal] = useState({ open: false, item: null, type: null });
  const [selectedBeanId, setSelectedBeanId] = useState('');
  const [selectedTemp, setSelectedTemp] = useState('hot');
  // Add a new state to remember the selected bean for Pour Over
  const [pendingPourOver, setPendingPourOver] = useState(null);

  useEffect(() => {
    const fetchMenuItems = async () => {
      const snap = await getDocs(collection(db, 'menuItems'));
      const items = [];
      snap.forEach(doc => {
        const data = doc.data();
        if (data.available !== false) {
          items.push({ id: doc.id, ...data });
        }
      });
      setMenuItems(items);
    };
    const fetchBeans = async () => {
      const snap = await getDocs(collection(db, 'pourOverBeans'));
      const beans = [];
      snap.forEach(doc => beans.push({ id: doc.id, ...doc.data() }));
      setPourOverBeans(beans);
    };
    fetchMenuItems();
    fetchBeans();
    const handleResize = () => setIsMobile(window.innerWidth < 700);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const openOptionModal = (item) => {
    if (item.name && item.name.trim().toUpperCase() === 'POUR OVER') {
      setSelectedBeanId(pourOverBeans[0]?.id || '');
      setModal({ open: true, item, type: 'bean' });
    } else if (item.category === 'COFFEE' || item.category === 'MILKBASED' || item.category === 'NON-COFFEE') {
      setSelectedTemp('hot');
      setModal({ open: true, item, type: 'temp' });
    } else if (item.category === 'BOWLS' || item.category === 'TOASTS_SLIDERS' || item.category === 'PASTRIES' || item.category === 'FOOD') {
      addToCart(item);
    } else {
      addToCart(item);
    }
  };

  const addToCart = (item, options = {}) => {
    setCart(cart => {
      const found = cart.find(i => i.id === item.id && (!options.beanId || i.beanId === options.beanId) && (!options.temperature || i.temperature === options.temperature));
      if (found) {
        return cart.map(i => (i.id === item.id && (!options.beanId || i.beanId === options.beanId) && (!options.temperature || i.temperature === options.temperature)) ? { ...i, quantity: i.quantity + 1 } : i);
      }
      return [...cart, { ...item, quantity: 1, itemNote: '', ...options }];
    });
    setModal({ open: false, item: null, type: null });
  };

  const updateQuantity = (id, qty, beanId, temperature) => {
    setCart(cart => cart.map(i => i.id === id && (beanId ? i.beanId === beanId : true) && (temperature ? i.temperature === temperature : true) ? { ...i, quantity: Math.max(1, qty) } : i));
  };

  const removeFromCart = (id, beanId, temperature) => {
    setCart(cart => cart.filter(i => !(i.id === id && (beanId ? i.beanId === beanId : true) && (temperature ? i.temperature === temperature : true))));
  };

  const updateItemNote = (id, note, beanId, temperature) => {
    setCart(cart => cart.map(i => i.id === id && (beanId ? i.beanId === beanId : true) && (temperature ? i.temperature === temperature : true) ? { ...i, itemNote: note } : i));
  };

  const handleSubmit = async () => {
    if (!cart.length || !tableNumber) return;
    setLoading(true);
    try {
      await addDoc(collection(db, 'orders'), {
        items: cart.map(({ id, name, price, quantity, itemNote, beanId, beanName, temperature }) => {
          const item = { id, name, price, quantity, itemNote };
          if (beanId !== undefined) item.beanId = beanId;
          if (beanName !== undefined) item.beanName = beanName;
          if (temperature !== undefined) item.temperature = temperature;
          return item;
        }),
        status: 'pending',
        createdAt: Timestamp.now(),
        tableNumber,
        notes: orderNotes,
      });
      setCart([]);
      setTableNumber('');
      setOrderNotes('');
      setSuccess(true);
      setTimeout(() => setSuccess(false), 2000);
    } finally {
      setLoading(false);
    }
  };

  // Group items by category
  const itemsByCategory = SECTION_MAP.reduce((acc, section) => {
    acc[section.category] = menuItems.filter(item => item.category === section.category);
    return acc;
  }, {});

  // Layout
  return (
    <div style={{ maxWidth: 1200, margin: '0 auto', padding: isMobile ? 12 : 32, display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: 32 }}>
      <div style={{ flex: 2, minWidth: 0 }}>
        <h2 style={{ fontSize: 28, fontWeight: 900, marginBottom: 18, letterSpacing: -1 }}>Waiter Order Entry</h2>
        <div style={{ marginBottom: 24, display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: 18, alignItems: isMobile ? 'flex-start' : 'center' }}>
          <label style={{ fontWeight: 700 }}>Table Number: <input value={tableNumber} onChange={e => setTableNumber(e.target.value)} style={{ marginLeft: 8, padding: 6, borderRadius: 6, border: '1.5px solid #bbb', fontSize: 16, width: 90 }} /></label>
          <label style={{ fontWeight: 700 }}>Order Notes: <input value={orderNotes} onChange={e => setOrderNotes(e.target.value)} style={{ marginLeft: 8, padding: 6, borderRadius: 6, border: '1.5px solid #bbb', fontSize: 16, width: isMobile ? 180 : 300 }} /></label>
        </div>
        {SECTION_MAP.map(section => (
          itemsByCategory[section.category]?.length > 0 && (
            <div key={section.category} style={{ marginBottom: 32 }}>
              <div style={{ fontWeight: 900, fontSize: 22, marginBottom: 10, letterSpacing: 0.5, borderBottom: '2px solid #eee', paddingBottom: 4 }}>{section.header}</div>
              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)', gap: 18 }}>
                {itemsByCategory[section.category].map(item => (
                  <div key={item.id} style={{ background: '#fafbfc', border: '1.5px solid #e0e0e0', borderRadius: 12, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.03)', transition: 'box-shadow 0.18s', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 8, cursor: 'pointer', minHeight: 90 }}
                    onMouseOver={e => e.currentTarget.style.boxShadow = '0 4px 18px rgba(34,34,34,0.10)'}
                    onMouseOut={e => e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.03)'}
                  >
                    <div style={{ fontWeight: 700, fontSize: 17, marginBottom: 2 }}>{item.name}</div>
                    <div style={{ color: '#444', fontWeight: 600, fontSize: 15 }}>QAR {item.price}</div>
                    <button onClick={() => openOptionModal(item)} style={{ marginTop: 6, background: '#222', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 18px', fontWeight: 700, fontSize: 15, cursor: 'pointer', transition: 'background 0.18s' }}>Add</button>
                  </div>
                ))}
              </div>
            </div>
          )
        ))}
        {/* Modal for options */}
        {modal.open && modal.type === 'bean' && (
          <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(30,30,30,0.72)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setModal({ open: false, item: null, type: null })}>
            <div style={{ background: '#fff', borderRadius: 16, padding: 24, minWidth: 320, position: 'relative', maxWidth: 600 }} onClick={e => e.stopPropagation()}>
              <button onClick={() => setModal({ open: false, item: null, type: null })} style={{ position: 'absolute', top: 8, right: 8, background: 'none', border: 'none', fontSize: 24, cursor: 'pointer' }}>×</button>
              <div style={{ fontWeight: 900, fontSize: 22, marginBottom: 18 }}>Pour Over Beans Options</div>
              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 18, maxHeight: '60vh', overflowY: 'auto' }}>
                {pourOverBeans.map(bean => (
                  <div key={bean.id} onClick={() => {
                    setPendingPourOver({ item: modal.item, bean });
                    setSelectedTemp('hot');
                    setModal({ open: true, item: modal.item, type: 'pourOverTemp' });
                  }}
                    style={{ cursor: 'pointer', border: '1.5px solid #eee', borderRadius: 10, padding: '12px 16px', background: '#fafbfc', boxShadow: '0 2px 8px rgba(0,0,0,0.03)', transition: 'box-shadow 0.18s, border 0.18s', fontWeight: 700 }}
                    onMouseOver={e => e.currentTarget.style.boxShadow = '0 4px 18px rgba(34,34,34,0.10)'}
                    onMouseOut={e => e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.03)'}
                  >
                    <div style={{ fontWeight: 900, fontSize: 17 }}>{bean.name}</div>
                    <div style={{ color: '#888', fontWeight: 500, fontSize: 15 }}>{bean.origin}</div>
                    <div style={{ color: '#888', fontWeight: 900, fontSize: 15, marginTop: 2 }}>{bean.price} QAR</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
        {/* New modal for Pour Over temperature selection */}
        {modal.open && modal.type === 'pourOverTemp' && pendingPourOver && (
          <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(30,30,30,0.72)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => { setModal({ open: false, item: null, type: null }); setPendingPourOver(null); }}>
            <div style={{ background: '#fff', borderRadius: 16, padding: 24, minWidth: 320, position: 'relative' }} onClick={e => e.stopPropagation()}>
              <button onClick={() => { setModal({ open: false, item: null, type: null }); setPendingPourOver(null); }} style={{ position: 'absolute', top: 8, right: 8, background: 'none', border: 'none', fontSize: 24, cursor: 'pointer' }}>×</button>
              <div style={{ fontWeight: 900, fontSize: 20, marginBottom: 16 }}>Select Option</div>
              <div style={{ display: 'flex', gap: 18, marginBottom: 18 }}>
                <button onClick={() => setSelectedTemp('hot')} style={{ flex: 1, background: selectedTemp === 'hot' ? '#222' : '#eee', color: selectedTemp === 'hot' ? '#fff' : '#222', border: 'none', borderRadius: 8, padding: '10px 0', fontWeight: 900, fontSize: 17, cursor: 'pointer' }}>Hot</button>
                <button onClick={() => setSelectedTemp('iced')} style={{ flex: 1, background: selectedTemp === 'iced' ? '#222' : '#eee', color: selectedTemp === 'iced' ? '#fff' : '#222', border: 'none', borderRadius: 8, padding: '10px 0', fontWeight: 900, fontSize: 17, cursor: 'pointer' }}>Iced</button>
              </div>
              <button onClick={() => {
                addToCart(pendingPourOver.item, { beanId: pendingPourOver.bean.id, beanName: pendingPourOver.bean.name, temperature: selectedTemp });
                setPendingPourOver(null);
              }} style={{ background: '#222', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 0', width: '100%', fontWeight: 900, fontSize: 17, cursor: 'pointer' }}>Add to Order</button>
            </div>
          </div>
        )}
        {/* Restore Hot/Iced modal for non-Pour Over items */}
        {modal.open && modal.type === 'temp' && (
          <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(30,30,30,0.72)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setModal({ open: false, item: null, type: null })}>
            <div style={{ background: '#fff', borderRadius: 16, padding: 24, minWidth: 320, position: 'relative' }} onClick={e => e.stopPropagation()}>
              <button onClick={() => setModal({ open: false, item: null, type: null })} style={{ position: 'absolute', top: 8, right: 8, background: 'none', border: 'none', fontSize: 24, cursor: 'pointer' }}>×</button>
              <div style={{ fontWeight: 900, fontSize: 20, marginBottom: 16 }}>Select Option</div>
              <div style={{ display: 'flex', gap: 18, marginBottom: 18 }}>
                <button onClick={() => setSelectedTemp('hot')} style={{ flex: 1, background: selectedTemp === 'hot' ? '#222' : '#eee', color: selectedTemp === 'hot' ? '#fff' : '#222', border: 'none', borderRadius: 8, padding: '10px 0', fontWeight: 900, fontSize: 17, cursor: 'pointer' }}>Hot</button>
                <button onClick={() => setSelectedTemp('iced')} style={{ flex: 1, background: selectedTemp === 'iced' ? '#222' : '#eee', color: selectedTemp === 'iced' ? '#fff' : '#222', border: 'none', borderRadius: 8, padding: '10px 0', fontWeight: 900, fontSize: 17, cursor: 'pointer' }}>Iced</button>
              </div>
              <button onClick={() => addToCart(modal.item, { temperature: selectedTemp })} style={{ background: '#222', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 0', width: '100%', fontWeight: 900, fontSize: 17, cursor: 'pointer' }}>Add to Order</button>
            </div>
          </div>
        )}
      </div>
      <div style={{ flex: 1, minWidth: isMobile ? 0 : 320, position: isMobile ? 'static' : 'sticky', top: 32, alignSelf: isMobile ? 'auto' : 'flex-start', background: '#fff', border: '2px solid #eee', borderRadius: 16, boxShadow: '0 4px 24px rgba(0,0,0,0.07)', padding: isMobile ? 16 : 28, marginTop: isMobile ? 24 : 0 }}>
        <h3 style={{ fontWeight: 900, fontSize: 20, marginBottom: 14, letterSpacing: 0.2 }}>Current Order</h3>
        {cart.length === 0 ? <div style={{ color: '#888', marginBottom: 12 }}>No items in order.</div> : (
          <table style={{ width: '100%', marginBottom: 18, fontSize: 15 }}>
            <thead>
              <tr style={{ color: '#888', fontWeight: 700 }}><th style={{ textAlign: 'left' }}>Item</th><th>Qty</th><th>Note</th><th>Remove</th></tr>
            </thead>
            <tbody>
              {cart.map(i => (
                <tr key={i.id + (i.beanId || '') + (i.temperature || '')}>
                  <td style={{ fontWeight: 700 }}>
                    {i.name}
                    {i.beanName && <span style={{ color: '#888', fontWeight: 500, fontSize: 13 }}> ({i.beanName})</span>}
                    {i.temperature && <span style={{ color: '#888', fontWeight: 500, fontSize: 13 }}> [{i.temperature}]</span>}
                  </td>
                  <td>
                    <input type="number" min={1} value={i.quantity} onChange={e => updateQuantity(i.id, parseInt(e.target.value) || 1, i.beanId, i.temperature)} style={{ width: 44, padding: 3, borderRadius: 5, border: '1.5px solid #bbb', fontSize: 15 }} />
                  </td>
                  <td>
                    <input type="text" value={i.itemNote} onChange={e => updateItemNote(i.id, e.target.value, i.beanId, i.temperature)} placeholder="Note" style={{ width: 80, padding: 3, borderRadius: 5, border: '1.5px solid #bbb', fontSize: 15 }} />
                  </td>
                  <td><button onClick={() => removeFromCart(i.id, i.beanId, i.temperature)} style={{ background: 'none', border: 'none', color: '#e74c3c', fontWeight: 900, fontSize: 18, cursor: 'pointer' }}>×</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        <button onClick={handleSubmit} disabled={loading || !cart.length || !tableNumber} style={{ fontWeight: 900, fontSize: 17, padding: '10px 0', background: '#222', color: '#fff', border: 'none', borderRadius: 8, width: '100%', marginTop: 8, cursor: loading || !cart.length || !tableNumber ? 'not-allowed' : 'pointer', opacity: loading || !cart.length || !tableNumber ? 0.7 : 1, transition: 'background 0.18s' }}>Submit Order</button>
        {success && <div style={{ color: 'green', marginTop: 12, fontWeight: 700 }}>Order submitted!</div>}
      </div>
    </div>
  );
};

export default WaiterTab; 